export function toPayload(action) {
    return action.payload;
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/@ngrx/effects/src/util.js
// module id = ../../../../@ngrx/effects/src/util.js
// module chunks = 7